module.exports = __webpack_public_path__ + "0ce3eda538e48bb4ed6d3c4594c44ceb.MP3";